module.exports = __webpack_public_path__ + "static/media/universal.f3f581a7.png";